import { Box, IconButton, Modal, Typography } from '@mui/material';
import { useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { NotesListDetailData } from '@converge/graphql';
import { NewNoteListDetail } from '../../../newNotes/new.note.list.detail';
import { modalCommonStyle } from '../../utils';
import { NewConvergeButton } from '../../../../presentation';

interface Props {
  onClose: () => void;
  note: NotesListDetailData;
}
export const MidtermTransactionNotesModal = ({ note, onClose }: Props) => {
  const handleOnClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Modal
      open={true}
      onClose={handleOnClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={modalCommonStyle({ height: 'auto' })}>
        <IconButton
          aria-label="close"
          onClick={handleOnClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'black',
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
          <Box className="modal-title">Midterm Transaction Note</Box>
        </Typography>
        <Box
          sx={{
            margin: '30px 0',
          }}
        >
          <NewNoteListDetail note={note} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: 27,
            right: 27,
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <NewConvergeButton
            onClick={onClose}
            variant="contained"
            sx={{
              backgroundColor: 'black',
              color: 'white',
              '&:hover': {
                backgroundColor: '#333',
              },
            }}
            label="CLOSE"
          ></NewConvergeButton>
        </Box>
      </Box>
    </Modal>
  );
};
